import { UIEvent, useMemo } from 'react';
import { BiPencil } from 'react-icons/bi';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { SpaceHierarchyReadModel } from '@client/api';
import { IconButton, isDefinedString } from '@client/toolkit';

import { PortfolioPaths } from '../../portfolio.router';

interface SpaceItemEditButtonProps {
  item: SpaceHierarchyReadModel | undefined;
}

export function SpaceItemEditButton({ item }: SpaceItemEditButtonProps) {
  const { buildingId } = useParams<{ buildingId: string }>();

  const navigate = useNavigate();
  const discriminator = useMemo(() => item?.discriminator, [item?.discriminator]);

  const editPath = useMemo(() => {
    if (item == null || !isDefinedString(item.id) || !isDefinedString(discriminator)) {
      return;
    }

    switch (discriminator) {
      case 'Building':
        return generatePath(PortfolioPaths.BuildingEdit, { buildingId });
      default:
        return generatePath(PortfolioPaths.SpaceEdit, { buildingId, spaceId: item.id, discriminator });
    }
  }, [buildingId, item, discriminator]);

  const handleClickEdit = (event: UIEvent, path: string) => {
    event.stopPropagation();

    navigate(path);
  };

  if (editPath == null) {
    return null;
  }

  return (
    <IconButton
      color="none"
      size="sm"
      fontSize="md"
      rounding="none"
      className="text-black hover:text-black active:bg-black/[0.10] rounded-lg"
      onClick={(e) => handleClickEdit(e, editPath)}
    >
      <BiPencil />
    </IconButton>
  );
}
